import type { RelatedSite } from './types';
import { theButler } from './the-butler';
import { butlerBell } from './butler-bell';
import { butlerAcademy } from './butler-academy';
import { queensButler } from './queens-butler';

/** 一覧・詳細・「ほかの関連サイト」で共有する表示順 */
export const relatedSites: RelatedSite[] = [theButler, butlerBell, butlerAcademy, queensButler];

export type { RelatedSite, RelatedBlock, RelatedSiteContent } from './types';
